/* eslint no-inner-declarations: 0 */
import $ from 'jquery';
import Handlebars from 'handlebars';
import tdaConfig from 'lib/util/tda.config';
import tdaAll from 'lib/tda/all';
import responsive from 'lib/responsive';
import AjaxOffers from 'components/ajax-offers';
import Slicker from 'components/slicker';
import getParameterByName from 'lib/getParameterByName';
import langFromUrl from 'lib/util/langFromUrl';
import anAddContext from 'lib/analytics/context.add';
import offerBlock from 'lib/analytics/blocks/offer.block';
import sectionBlock from 'lib/analytics/blocks/section.block';
import anClicks from 'lib/analytics/click';
import anClickManual from 'lib/analytics/click.manual';
import blocks from 'lib/analytics/blocks/index';
import carouselToggle from 'features/header/carousel.toggle';
import txtOfferItem from './offer.header.item.hbs';
import 'lazyload';

var __tmplOfferItem = Handlebars.compile(txtOfferItem);
var __lang = langFromUrl();
var getCarouselOffersInitiated = false;

const carouselOffersHeader = {
  // TODO: add more things to the config and get rid of the XSL
  // XSL for this is pretty insane though... refactor!! But there's too many damn
  // options for the TDA within the carousel editor
  // Note that the 'Homepage' skin is needed on a carousel for offers carousels to work. Otherwise it defaults to no offers
  load: function (el, config) {
    var self = this;
    self.$el = $(el);
    self.config = {
      ...config,
      params: {
        plusCashLabelCash: tdaConfig.pluscash.cash,
        plusCashLabelLease: tdaConfig.pluscash.lease,
        plusCashLabelApr: tdaConfig.pluscash.apr,
      },
      i18n: {
        bonusCash: __lang === 'es' ? 'Bono en efectivo' : 'Bonus Cash',
        bonusCashAlt: __lang === 'es' ? 'Reembolso' : 'Cash Back',
        bonus: __lang === 'es' ? 'Bono' : 'Bonus',
        ...config.i18n,
      }
    };
    var isHeaderExpanded = false;
    var $offersHeader = $('.js-offers-header', self.$el);

    // BAT-5903 New toggle to turn on/off carousel (on by default)
    // if the TDA has not updated the DCR with the new fields don't bother
    if (config.carouselToggleDesktop || config.carouselToggleMobile) {
      carouselToggle.handleCarouselToggle(
        config.carouselToggleDesktop,
        config.carouselToggleMobile
      );
    }

    function openCarousel() {
      if (!$('#disable-expansion').length) {
        var $header = $('.js-offers-header.carousel-header-mini');
        var $mini = $header.find('.minified');
        var $full = $header.find('.full');
        var $carouselHeaderBackgrounds = $('.carousel-header-backgrounds');
        // BAT-3193 Fade in images on every collapse/expand
        $carouselHeaderBackgrounds.fadeIn(500, function () {});


        if ($header.hasClass('is-minified')) {
          // expand
          $header.css({
            height: $mini.height()
          });
          $full.show();
          $('#header-expand-button-inner').addClass('active');

          $header.animate({
            height: $full.height()
          }, 300, function () {
            $header.removeClass('is-minified').addClass('is-expanded');

            $mini.hide();
            $header.css('height', 'auto');
          });

          $mini.animate({
            top: $mini.height() * -1,
            opacity: 0.5
          }, 300);

          $full.animate({
            top: $mini.height() * -1,
            opacity: 1
          }, 300, function () {
            $full.css({
              top: 0
            });
          });

          isHeaderExpanded = true;
          $('#header-expand-button-outer').addClass('deactivate');
          // only build if it has not previously been built already
          var isAlreadyBuilt = $header.find('.slick-slider').length;
          if (!isAlreadyBuilt) {
            carouselOffersHeader.buildCarousel();
          } else {
            // var foo = carouselOffersHeader.currentCarousel;
            // carouselOffersHeader.currentCarousel.reloadSlider();
          }

          self.hideExpandButton(); // do we need this?
        }

        if (carouselOffersHeader.hideMobileCta()) {
          $('.cta-content-wrap').hide();
        }
      }
    }

    function closeCarousel() {
      var $header = $('.js-offers-header.carousel-header-mini').not('[data-slide]');
      var $mini = $header.find('.minified');
      var $full = $header.find('.full');
      var $carouselHeaderBackgrounds = $('.carousel-header-backgrounds');

      if ($header.hasClass('is-expanded')) {
        // minify
        $header.css({
          height: $full.height()
        });

        $mini.show();
        $full.css({
          top: $mini.height() * -1
        });
        $('#header-expand-button-inner').removeClass('active');

        $header.animate({
          height: $mini.height()
        }, 300, function () {
          $header.removeClass('is-expanded').addClass('is-minified');
          $full.hide();
          $header.css('height', 'auto');
        });

        // remove our DOM element that has all the BG images
        $carouselHeaderBackgrounds.fadeOut(500, function () {});

        $mini.animate({
          top: 0,
          opacity: 1
        }, 300).fadeTo();

        $full.animate({
          top: 0,
          opacity: 0.5
        }, 300, function () {});

        isHeaderExpanded = false;
      }
    }

    if ($offersHeader.length) {
      self.init();
      anAddContext(self.$el, sectionBlock('header_carousel'));
      anClicks(self.$el);

      // BAT-2163 Open a collapsed carousel
      $('.js-header-carousel-show-hide').not('.js-header-carousel-show-hide.active').on('click', function () {
        var $this = $(this);
        var ariaLabel = '';
        if ($this.hasClass('active')) {
          ariaLabel = langFromUrl() === 'es' ? 'Anuncio cerrado. Expandir para ver el más.' : 'Collapsed banner. Expand to see entire carousel.';
          closeCarousel();
        } else {
          ariaLabel = langFromUrl() === 'es' ? 'Anuncio abierto. Cerrar para ver menos.' : 'Expanded banner. Collapse to see less carousel';
          anClickManual(self.$el, $this);
          if (!getCarouselOffersInitiated && $offersHeader.find('div[data-offerid]').not('.slick-cloned').length > 0) {
            carouselOffersHeader.getCarouselOffers();
          }
          openCarousel();
        }
        $('#expander').attr('aria-label', ariaLabel);
      });

      $('.js-offers-header #header-expand-button-outer').off('mouseover'); // remove event that is attached via old click button
      $('.js-offers-header').off('mouseover').on('mouseover', function () {
          if (!isHeaderExpanded) {
            $('#header-expand-button-expand').show();
            var expandWidth = $('#header-expand-button-expand').outerWidth(true);
            var plusWidth = $('#header-expand-button-plus').outerWidth(true);

            $('#header-expand-button-inner').stop().animate({
              width: (expandWidth + plusWidth)
            }, 200);
          }
        }).off('mouseout')
        .on('mouseout', function () {
          if (!isHeaderExpanded) {
            self.hideExpandButton();
          }
        });
    }
  },

  init: function () {
    /* if our header is collapsed by default
      - we need to see which masthead to use (if multiple exist)
      - we do NOT need to getOffers by default */

    $('.minified.is-visible').children('a').attr('tabindex', '0');
    $('.minified.is-visible').children('a').attr('aria-hidden', 'false');



    if (screen.width < 960) {
      $('.minified.is-visible').attr('tabindex', '0');
      $('.cta-subtitle').attr('aria-hidden', 'true');
      $('.cta-title').attr('aria-hidden', 'true');
      $('.cta-description').attr('aria-hidden', 'true');
      $('.minified.is-visible').children('img').attr('aria-hidden', 'false');

    }

    $('#expander').on('keypress', function (e) {
      if (e.keyCode !== 9) {
        $('#header-expand-button-inner').click();
      }
    })

    if (this.headerCollapsedByDefault()) {
      var mastheadArr = this.getVehicleSpecificMastheads();
      var result;
      // if we have an array of mastheads, we need to see which one to use
      if (mastheadArr.length >= 1) {
        var pageBasedSeries = this.getPageBasedSeries();
        if (!pageBasedSeries) {
          result = mastheadArr[0];
          this.buildVehicleSpecificMasthead(result);
          return;
        }
        // find the series that is present in the DOM of the page we're on, if any
        var curPageSeries = pageBasedSeries.toString();
        // Toss into an array, to handle offers that contain multiple series (we need to find the first masthead)
        curPageSeries = curPageSeries.split(',');
        if (curPageSeries.length > 0) {
          // if we have a curPageSeries;
          for (var i = 0; i < curPageSeries.length; i += 1) {
            // get the first (in case there are more than one) item, from the mastheadArr whose obj contains curPageSeries
            result = mastheadArr.filter(function (obj) {
              if (obj.series === curPageSeries[i]) {
                return curPageSeries[i];
              }
            })[0];
            if (result) {
              break;
            }
          }
          // if we don't have a result, use the first item
          if (!result) {
            result = mastheadArr[0];
          }
        } else {
          // else, just get the first
          result = mastheadArr[0];
        }
        // now build our collapsed masthead using this specific masthead data
        this.buildVehicleSpecificMasthead(result);
      }
    }
    // this is because ajax-offers.js relies on it!
    carouselOffersHeader.getCarouselOffers();
    // this.headerExpanderAda();
  },

  hideExpandButton: function () {
    $('#header-expand-button-inner').stop().animate({
      width: 18
    }, 200, function () {
      $('#header-expand-button-expand').hide();
    });
  },

  headerCollapsedByDefault: function () {
    // if our header has a class of 'carousel-header-mini', then it was/is closed by default
    var isMini = $('.js-offers-header').hasClass('carousel-header-mini');
    return isMini;
  },

  // BAT-4718 ADA.
  updateCarouselArrows: function () {
    var sns = langFromUrl() === 'es' ? 'Ver siguente diapositiva' : 'Show Next Slide';
    var sps = langFromUrl() === 'es' ? 'Ver diapositiva anterior' : 'Show Previous Slide';
    $('.carousel-next button').attr('tabIndex', '0').attr('aria-label', sns);
    $('.carousel-prev button').attr('tabIndex', '0').attr('aria-label', sps);
  },

  getCarouselOffers: function () {
    getCarouselOffersInitiated = true;
    var self = this;
    var $offersHeader = $('.js-offers-header', self.$el);
    // get each carousel item that contains a data-offerid attribute
    var $itemsWithOffers = $offersHeader.find('div[data-offerid]').not('.slick-cloned');
    // a carousel MAY NOT contain offers. If not, just build the carousel and end
    if ($itemsWithOffers.length === 0) {
      if ($offersHeader.hasClass('header-is-open')) {
        carouselOffersHeader.buildCarousel();
      }
      return;
    }

    // Build string of offerId's
    var offerIdsString = '';
    var tmpOffersFound = [];
    var kount = 0;
    $.each($itemsWithOffers, function () {
      // removing _es from offerId as offers service uses lang parameter no <offer_id>_es
      var tmpOfferId = $(this).data('offerid').toString().replace(/_es$/, ''); // note: we now remove _es from output in the XSL file
      // Prevent duplicate offerId's in our offerstring
      if (tmpOffersFound.indexOf(tmpOfferId) === -1) {
        tmpOffersFound.push(tmpOfferId);
        if (kount === 0) {
          offerIdsString = '&offerId=' + tmpOfferId;
        } else {
          offerIdsString += ',' + tmpOfferId;
        }
        kount += 1;
      }
    });
    /*--------------------------------------------------------------------
    GET OFFERS
    We still need to pass it our template to AjaxOffers, even though we won't actually use it ($('#template-offer-header-item'))
    AjaxOffers was previously built for use with isotope,
    where we can render a big block of HTML, instead of individual pieces.
    In this case though, we need to render individual pieces
    --------------------------------------------------------------------*/
    // var offersHeaderAjax = new AjaxOffers('/offers-service/OFFERS/byOfferId?pageSize=5' + offerIdsString, true, true, $('#foo-bar-empty'), false, false);
    var offersHeaderAjax = new AjaxOffers('/offers-service/v1/marketing/offers/' + offerIdsString, true, true, $('#foo-bar-empty'), false, false);

    offersHeaderAjax.init();

    // no offers found in offers service, just build the carousel (if our header is open)
    $(offersHeaderAjax).on('NO_ITEMS_FOUND', function () {
      if ($offersHeader.hasClass('header-is-open')) {
        carouselOffersHeader.buildCarousel();
      }
    });

    $(offersHeaderAjax).on('COMPLETE', function (event, $newItems, data) {
      // console.log('%c header complete:', 'background: red; color: white');
      // console.log($newItems);
      var validOffersDisplaying = [];
      for (var i = 0; i < data.items.length; i += 1) {
        validOffersDisplaying.push(data.items[i].id);
        let ctx = {
          i18n: self.config.i18n,
          params: self.config.params,
          items: [data.items[i]]
        };
        let $found = $offersHeader.find(`div[data-offerid="${data.items[i].id}"]`);

        console.log('CTX for header offer: ', ctx); // eslint-disable-line no-console
        $found
          .find('.cta-content')
          .html(__tmplOfferItem(ctx));
        anAddContext($found, offerBlock(data.items[i]));
      }


      /*--------------------------------------------------------------------
      IF NO OFFER FOR OFFERID (likely, it's an expired offer)
      // If data for an offer isn't returned, then it doesn't exist in the offers service
      // so, we push all offers that ARE used to an array (validOffersDisplaying, above), and for those inline offer-id's
      // that are NOT in our array, we display the default block of copy
      // NOTE: we are NOT yet accounting for when validOffersDisplaying.length = 0
      // also note: we may not need to do ANYTHING at all with an invalid offer, since we display default copy
      --------------------------------------------------------------------*/
      $.each($itemsWithOffers, function () {
        var curId = $(this).data('offerid');
        if (validOffersDisplaying.indexOf(curId) === -1) {
          $('div[data-offerid="' + curId + '"]').addClass('is-invalid-offer');
        }
      });

      if ($offersHeader.hasClass('header-is-open')) {
        carouselOffersHeader.buildCarousel();
      }
    });
  },

  getVehicleSpecificMastheads: function () {
    // get all mastheads, turn them into an array of objects
    var initMastheadArr = $('.js-masthead');
    var finalMastheadArr = [];
    for (var i = 0; i < initMastheadArr.length; i++) {
      var $curMasthead = $(initMastheadArr[i]);
      var dataAsString = $curMasthead.data('masthead');
      var tmpArr = dataAsString.split('|');
      var tempObj = {
        series: tmpArr[0],
        disableExpansion: tmpArr[1],
        imageMastheadCollapsed: tmpArr[2],
        imageMastheadMobileCollapsed: tmpArr[3],
        imageMastheadCollapsedAlttext: tmpArr[4],
        ImageMastheadDestination: tmpArr[5]
      };
      finalMastheadArr.push(tempObj);
    }
    return finalMastheadArr;
  },

  buildVehicleSpecificMasthead: function (curVehicleMasthead) {
    var $newMastheadBackground = $('.js-offers-header').children('.minified');
    var $newMastheadMobile = $newMastheadBackground.children('img');
    var newMastheadBackgroundImg = tdaAll.localImgPath(curVehicleMasthead.imageMastheadCollapsed);
    var newMastheadExpandDisabled = curVehicleMasthead.disableExpansion;
    var newMastheadDestination = curVehicleMasthead.ImageMastheadDestination;
    var $mastheadDestinationAnchor = $newMastheadBackground.children('a');

    // if disable expansion is true, hide the expander
    if (newMastheadExpandDisabled === 'true') {
      $('.js-offers-header').addClass('expand-is-disabled');
    }

    // Update masthead BG image, only on md and lg!
    if (responsive() !== 'sm') {
      $newMastheadBackground.css({
        'background-image': 'url(' + newMastheadBackgroundImg + ')'
      });
    } else {
      $newMastheadMobile.lazy({
        bind: 'event',
        delay: 0,
        afterLoad: function ($el) {
          $el.removeClass('hidden-sm hidden-md');
        }
      });
    }

    // update or remove the masthead destination link
    if (newMastheadDestination) {
      var customUrlArr = newMastheadDestination.split('/'); // split it into an array, so we can drop the unused parts
      if (customUrlArr[1] == 'sites') {
        customUrlArr.splice(0, 3); // Drop the first 3 items from array ('', 'sites', 'TDA')
        customUrlArr.unshift('/' + tdaConfig.site.context_url);
      }
      var finalUrl = customUrlArr.join('/'); // create URL from array

      if (finalUrl.length > 0) {
        $mastheadDestinationAnchor.attr('href', finalUrl);
      } else {
        $mastheadDestinationAnchor.remove();
      }
    } else {
      $mastheadDestinationAnchor.remove();
    }
  },

  /*---------------------------------------------------------------------------
  BAT-2440: we need this to determine which item in our mastheadArr to display
  get current vehicle from the following pages:
  - Offer Detail page
  - Vehicle Info page
  - Simplified Comparison page
  - Inventory Detail page
  - Vehicle Offers page
  ---------------------------------------------------------------------------*/
  getPageBasedSeries: function () {
    // Offer Detail pages
    // test URLs:
    // http://test.newengland.aws.buyatoyota.com/en/offer-detail/?offerid=camry_cash_1458153005263 (testcarousel6)
    // http://test.newengland.aws.buyatoyota.com/en/offer-detail/?offerid=rav4_lease_1458153007902 (testcarousel6)
    if ($('div#offer-detail').length) {
      var offerSeries = $('div#offer-detail').data('series');
      if (offerSeries === 'multi') {
        offerSeries = $('div#offer-detail').data('series-all');
      }
      return offerSeries;

      // vehicle info
      // test URL: http://test.newengland.aws.buyatoyota.com/en/vehicles/priusc/ (testcarousel6)
      // http://test.newengland.aws.buyatoyota.com/en/vehicles/prius/
      // http://test.newengland.aws.buyatoyota.com/en/vehicles/camryhybrid/
      // http://test.newengland.aws.buyatoyota.com/en/vehicles/highlander/ (testcarousel6, no highlander masthead)
      // http://test.newengland.aws.buyatoyota.com/en/vehicles/avalon/ (testcarousel5, sample of older format (single masthead))
    }
    if ($('div#page-vehicle-info').length) {
      return $('div#page-vehicle-info').data('series').toString();

      // simplified comparison page
      // test URLs: http://test.newengland.aws.buyatoyota.com/en/compare/16-rav4-escape.page (testcarousel6)
    }
    if ($('#vehicle-compare-offer').length) {
      return $('#vehicle-compare-offer').attr('series');

      // Inventory detail page (and inventory search results)
      // test URL: http://test.newengland.aws.buyatoyota.com/en/inventory-detail/?vehicleid=BRD_TOY-YR_2017-MDL_3544-XCOL_0218-ICOL_LD20-ACY+XL-ACY+2T-PKG+FE&series=avalon
      // all Inventory Detail pages use  (testcarousel6)
      // TODO: inv detail page DOM is not updated in time for this.
    }
    if ($('#inventory-detail').length) {
      // return $('#inventory-detail').data('series');
      return getParameterByName('series');

      // Offers vehicle page
      // test URLs: http://test.newengland.aws.buyatoyota.com/en/offers/corolla/ (testcarousel6)
      // http://test.newengland.aws.buyatoyota.com/en/offers/rav4/ (testcarousel6)
    }
    if ($('#offers-vehicle-page').length) {
      return $('#offers-vehicle-page').data('series');
    }
    return '';
  },

  buildCarousel: function () {
    var self = this;
    var slideCount = $('.carousel-header-offers.full .item').length - 1;

    // if there's only one slide, then slideCount will be 0!
    if (slideCount === 0) {
      var $carouselNext = $('.carousel.carousel-header-offers .carousel-next');
      var $carouselPrev = $('.carousel.carousel-header-offers .carousel-prev');
      $carouselNext.remove();
      $carouselPrev.remove();

      var $contentWrap = $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap');
      var firstSlideBgSingle = $('.carousel-header-offers.full .item').data('bgimg');
      $('.carousel-header-backgrounds').remove();
      $('.js-offers-header').prepend('<div class="carousel-header-backgrounds"></div>');
      $contentWrap.css('opacity', 1);

      if (responsive() === 'md' && !$('html').hasClass('tablet')) {
        $('.mobile-fullcanvas').addClass('visible-md');
      }

      if (responsive() === 'lg') {
        $('.carousel-header-backgrounds').css({
          'background-image': 'url(' + firstSlideBgSingle + ')'
        });
        // only a one slide, so we never get our lazy loading FG img from onSliderLoad. Do that here
        self.lazyLoadImages($('.carousel-header-offers.full .item').eq(0).find('.full-height-md'));
      }
    }

    function doCarousel() {
      var $scope = self.$el;
      // $('*', $('.item', $scope.$el)).removeClass('hidden-sm hidden-md hidden-lg');
      // $('*', $('.item', $scope.$el)).css('opacity', 1);
      var headerOffers = new Slicker({
        $slider: $('.carousel-header-offers .carousel-inner'),
        slickOptions: {
          mobileFirst: true,
          slide: '.item',
          slidesToShow: 1,
          useCSS: true,
          infinite: true,
          autoplay: false,
          arrows: false,
          adaptiveHeight: false,
          initFunction: function () {
            var index = 0;

            var firstSlideBg = $('.carousel-header-offers.full .item').eq(index).data('bgimg');
            var $firstSlideForeground = $('.carousel-header-offers.full .item').eq(index).find('.full-height-md');

            if ($('html').hasClass('mobile') || responsive() === 'sm') {
              $('.minified.is-visible').attr('tabindex', '0');
              var slickViewportHeight = $('.carousel-header-offers').height();
              if (carouselOffersHeader.hideMobileCta()) {
                slickViewportHeight = 0;
              }
              var heights = $("div.desktop-caption-wrapper").map(function () {
                return $(this).height();
              }).get();
              var highest = Math.max.apply(null, heights);

              var imageHeights = $("div.slick-slide img.lazy-not-lg").map(function () {
                return $(this).height();
              }).get();
              var imageHighest = Math.max.apply(null, imageHeights);

              var $slideContentMobile = $('#js-slide-cta').detach();
              $('.carousel-header-offers').css({
                'min-height': (highest + imageHighest + 40)
              }).prepend($slideContentMobile);


              var slickSliderHeights = $("div.slick-slider").map(function () {
                return $(this).height();
              }).get();
              var slickSliderHeight = Math.max.apply(null, slickSliderHeights);

              $("div.slick-list").css({
                'min-height': slickSliderHeight
              });

              $("div.slick-track").css({
                'min-height': slickSliderHeight
              });

              $("div.slick-slide").css({
                'min-height': slickSliderHeight
              });

              $("div.desktop-caption-wrapper").css({
                'height': highest + 10
              });

            }
            if ($('html').hasClass('tablet') || responsive() === 'md') {
              var $slideContentMobile1 = $('#js-slide-cta').detach();
              $('.carousel-header-offers').prepend($slideContentMobile1);
            }

            $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').css('opacity', 0).attr('style', '');
            $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').eq(index).css('opacity', 1);
            $('.carousel-header-backgrounds').remove();
            $('.js-offers-header').prepend('<div class="carousel-header-backgrounds"></div>');
            $('.carousel-header-backgrounds').css({
              'background-image': 'url(' + firstSlideBg + ')'
            });
            self.lazyLoadImages($firstSlideForeground);

            if (responsive() === 'lg') {
              var firstActiveSlideBg = $('.carousel-header-offers.full .item.slick-active').eq(index).data('bgimg');
              var $firstActiveSlideForeground = $('.carousel-header-offers.full .item').eq(index).find('.full-height-md');
              $('.carousel-header-backgrounds').css({
                'background-image': 'url(' + firstActiveSlideBg + ')'
              });
              self.lazyLoadImages($firstActiveSlideForeground);
            }

            carouselOffersHeader.updateCarouselArrows();
            carouselOffersHeader.prepareCarouselForADA(index);
            carouselOffersHeader.handleFullCanvasLinks(index);
            anAddContext(
              $scope,
              blocks.listItemBlock(index)
            );

            var $bxPrev = $('.carousel-header-offers').find('.bx-prev');
            var $bxNext = $('.carousel-header-offers').find('.bx-next');
            $bxPrev.keydown(function (event) {
              if (event.keyCode !== 13 && event.keyCode !== 9) {
                event.preventDefault();
                event.stopPropagation();
                return;
              }
              if (event.keyCode === 13) {
                $bxPrev.trigger('click');
              }
            });
            // NEXT ARROW KEY DOWN BAT-4016
            $bxNext.keydown(function (event) {
              if (event.keyCode !== 13 && event.keyCode !== 9) {
                event.preventDefault();
                event.stopPropagation();
                return;
              }
              if (event.keyCode === 13) {
                $bxNext.trigger('click');
              }
            });
            if (carouselOffersHeader.hideMobileCta()) {
              var mobileCtaHeight = $('.cta-content-wrap').height();
              $('.cta-content-wrap').hide();
              var $carouselSlider = $('.carousel-inner').children('.slick-list'); // this is the slider for the carousel
              var carouselSliderHeight = 0;
              if ($carouselSlider.length > 0) {
                // get the height of the carousel slider component, and then
                // use that to calculate the new height
                //
                // use setTimeout to give the slider time to resize itself when loading the images, otherwise
                // the calculation in resizeCarouselSlider will be off
                setTimeout(function () {
                  carouselSliderHeight = $carouselSlider.height();
                  carouselOffersHeader.resizeCarouselSlider($carouselSlider, mobileCtaHeight, carouselSliderHeight);
                }, 1000);
              }
            }

            var mfc = $('.mobile-fullcanvas');
            mfc.each(function (index, item) {
              if ($('html').hasClass('portrait') && $('html').hasClass('tablet')) {
                $(item).addClass('show-tablet');
              }
              if ($('html').hasClass('landscape') && $('html').hasClass('tablet')) {
                $(item).removeClass('show-tablet');
              }
              if (responsive() === 'md' && !$('html').hasClass('tablet')) {
                $(item).addClass('visible-md');
              }
            });
          },
          beforeFunction: function (e, slick, currentSlide, nextSlide) {
            var $el = $(slick.$slides[nextSlide]);

            var $foreground = $el;
            if (responsive() === 'lg') {
              $foreground = $el.find('.full-height-md');
            }
            self.lazyLoadImages($foreground);
            $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').eq(currentSlide).css('opacity', 0);
            $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').eq(nextSlide).css('opacity', 1);
            $el.css('display', 'block');
            var slideBg = $($el).data('bgimg');
            $('.carousel-header-backgrounds').css({
              'background-image': 'url(' + slideBg + ')'
            });

            // BAT-2778 REMOVE POINTER EVENTS FROM ALL SLIDES.
            $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').each(function (index, item) {
              $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').eq(index).css('pointer-events', 'none');
            });
          },
          afterFunction: function (e, slick, currentSlide) {
            var $el = $(slick.$slides[currentSlide]);
            $el.css('display', 'block');
            // // BAT-2778 ADD POINTER EVENTS TO CURRENT SLIDE.
            $('.carousel-header-offers.full #js-slide-cta .cta-content-wrap').eq(currentSlide).css('pointer-events', 'all');

            carouselOffersHeader.hideInactiveCarouselSlides(currentSlide);
            carouselOffersHeader.prepareCarouselForADA(currentSlide);
            anAddContext(
              $scope,
              blocks.listItemBlock(currentSlide)
            );
          },
          desktop: {
            arrows: true,
            adaptiveHeight: true,
            infinite: true,
            draggable: false,
            appendArrows: $('.carousel-header-offers .carousel-inner'),
            prevArrow: '<div class="carousel-prev datalayer-link bx-prev-large" data-linktext="model_selector_previous"><button class="bx-prev unstyled" aria-label="show previous model"><i class="icon icon-arrow-thin-left"></i></button></div>',
            nextArrow: '<div class="carousel-next datalayer-link bx-next-large" data-linktext="model_selector_next"><button class="bx-next unstyled" aria-label="show next model"><i class="icon icon-arrow-thin-right"></i></button></div>'
          },
          tablet: {
            dots: true,
            arrows: false,
            adaptiveHeight: false,
            infinite: true
          }
        }
      });
      carouselOffersHeader.currentCarousel = headerOffers.$slider;
      // extra insurance against the carousel automatically changing height
      // if the mobile CTA is hidden
      carouselOffersHeader.currentCarousel.on('setPosition', function (event, slick) {
        if (carouselOffersHeader.hideMobileCta() && slick.getOption('adaptiveHeight')) {
          slick.setOption('adaptiveHeight', false);
        }
      });
    }

    if (responsive() !== 'lg') {
      // load the first img of mobile, needs to happen before our slideshow is built
      // use a delay in order to hold off on downloading the first img
      $('img.lazy-not-lg', '.carousel-header-offers .item.active').lazy({
        bind: 'event',
        delay: 0,
        afterLoad: function ($el) {
          $el.removeClass('hidden-sm  hidden-md');
          doCarousel();
        }

      });
    } else {
      doCarousel();
    }
  },

  lazyLoadImages: function ($scope) {
    if (responsive() !== 'lg') {
      $('img.lazy-not-lg', $scope).lazy({
        bind: 'event',
        delay: 0,
        afterLoad: function ($el) {
          $el.removeClass('hidden-sm hidden-md');
        }
      });
      if (responsive() === 'md') {
        $('img.lazy', $scope).addClass('hidden-sm hidden-md hidden-lg');
      }
    } else {
      $('img.lazy', $scope).lazy({
        bind: 'event',
        delay: 0,
        afterLoad: function ($el) {
          $el.removeClass('hidden-sm hidden-md hidden-lg');
        }
      });
      $('img.lazy', $scope).removeClass('hidden-sm hidden-md hidden-lg');
    }
  },

  handleFullCanvasLinks: function (index) { // BAT-4781
    // FULL CANVAS LINKS NEED TO BE HIDDEN. ONLY VISIBLE SLIDES WITH THIS FULL CANVSAS LINK SHOULD BE ACCESIBLE.
    //$('.carousel-header-offers').find('.carousel-header-fullcanvas-link').each(function (idx, item) {
    // $(item).attr('tabIndex', '-1');
    //});
    // $('.carousel-header-offers.full .item').eq(index).find('.carousel-header-fullcanvas-link').css('border', '1px solid green');
    $('.carousel-header-offers.full .item').eq(index).find('.carousel-header-fullcanvas-link').attr('tabIndex', '0');
  },

  prepareCarouselForADA: function (index) {
    setTimeout(function () { // BAT-4358
      // $('.carousel-header-offers ').find('.carousel-header-fullcanvas-link').attr('tabIndex', '-1');
      var ctas = $('#js-slide-cta .cta-content-wrap');
      ctas.each(function (slideIndex, item) {
        $(item).attr('data-index', slideIndex);
        if (slideIndex === index) {
          // $(item).attr('tabIndex', '0');
          if (!carouselOffersHeader.hideMobileCta()) {
            $(item).show();
          }
        } else {
          // $(item).attr('tabIndex', '-1');
          $(item).hide();
        }
      });
      $('.datalayer-link-slick-dot').each(function (idx, item) {
        var totalSlides = $('.datalayer-link-slick-dot').length;
        var slideNum = idx + 1;
        var alabel = 'show slide ' + slideNum + ' of ' + totalSlides;
        if (langFromUrl() === 'es') alabel = 'muestra la diapositiva ' + slideNum + ' de ' + totalSlides;
        $(item).attr('aria-label', alabel).attr('role', 'button');
        $(item).attr('tabindex', 0);
      });
    }, 500);
  },

  hideInactiveCarouselSlides: function (newIndex) {
    // ADA BAT-4358 make none visible cta's non tabbable.
    var ctas = $('#js-slide-cta .cta-content-wrap');
    ctas.each(function (slideIndex, item) {
      var dinum = Number($(item).attr('data-index'));
      if (dinum === newIndex) {
        // $(item).attr('tabIndex', '0');
        if (!carouselOffersHeader.hideMobileCta()) {
          $(item).show();
        }
      } else {
        // $(item).attr('tabIndex', '-1');
        $(item).hide();
      }
    });
  },

  headerExpanderAda: function () {
    // $('#header-expand-button').on('keyup', function (event) {
    $('#expander').on('keyup', function (event) {
      if (event.keyCode === 32 || event.keyCode === 13) {
        $('.js-header-carousel-show-hide').trigger('click');
        event.preventDefault();
      }
    });
  },

  hideMobileCta: function () {
    var self = this;
    // Uncomment for TESTING to simulate the value in the DCR
    // self.config.carouselToggleMobile = 'on';
    // self.config.carouselToggleMobileCta = 'off';
    if (responsive() === 'sm' &&
      (self.config.carouselToggleMobile === 'on' &&
        self.config.carouselToggleMobileCta === 'off')) {
      return true;
    }
    return false;
  },

  // if the Mobile CTA toggle is turned off, not only do we hide the mobile CTA,
  // but also need to resize the slicker carousel, this is kind of hacky, but
  // is there a better way to do this?  TODO: someone find a better way
  resizeCarouselSlider: function ($carouselSlider, mobileCtaHeight, carouselSliderHeight) {
    var _mobileCtaHeight = mobileCtaHeight;
    if (!mobileCtaHeight) {
      _mobileCtaHeight = 170; // this is approximately the height of the mobile CTA
    }
    if (carouselSliderHeight > _mobileCtaHeight) {
      var newCarouselSliderHeight = carouselSliderHeight - _mobileCtaHeight;
      $carouselSlider.css('height', newCarouselSliderHeight);
    }
  },

  // store carousel selector here, so we can use .destroySlider() later
  currentCarousel: []
};

export default carouselOffersHeader;
